import { makeStyles } from '@material-ui/core/styles';
export const useStyles = makeStyles(theme => ({
  container: {
    display: 'flex',
    height: '100%'
  },
  userList: {
    width: '50%',
    display: 'flex',
    flexDirection: 'column',
    [theme.breakpoints.down('sm')]: {
      width: '100%'
    }
  },
  chat: {
    width: '50%',
    display: 'flex',
    justifyContent: 'center'
  }
}));